import { Skeleton, usePageWidth } from '@fs/zion-ui'
import { boolAttr } from '@fs/zion-frontend-friends'
import React from 'react'
import { noItemsMessageCss } from './noItemsMessageStyles'

export default function NoItemsMessageSkeleton(): JSX.Element {
  const isDense = usePageWidth()({ default: true, lg: false })

  return (
    <div aria-hidden css={noItemsMessageCss} is-dense={boolAttr(isDense)}>
      <Skeleton.Icon />
      <Skeleton.Paragraph lineCount={1} size="sm" maxWidth={160} />
    </div>
  )
}
